<template>
  <div class="width-100-percent">
   
    <vc-date-picker
      @input="onDateRangeChange($event)"
      :mode="mode"
	    v-model="selectedDate"
      :masks="{ data: ['DD/MM/YY'], input: 'L' }"
      :popover="{ visibility: 'click' }"
      :disabled="disabled"
      class="mt-3"
    >
    </vc-date-picker>
    <a @click="cleanDate()">
       <img :width="datePickerImageWidth()" class="calendar_clean" :src="datePickerImageSource()"/>
    </a>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    value: {
      type: [String, Date],
      required: false,
      default: ''
    },
    generic_date: {
      required: false,
    },
    mode: {
      required: true,
    },
    filter_object: {
      required: true,
    },
    field_to_update:{
      required: true,
    },
    disabled:{
      required: false,
      default: false
    }
  },
  computed: {
    formattedDate() {
      if (this.mode == "range" && this.selectedDate && this.selectedDate.start && this.selectedDate.end) {
        return {
          start_date: moment(this.selectedDate.start).format("YYYY-MM-DD"),
          end_date: moment(this.selectedDate.end).format("YYYY-MM-DD"),
        };
      } else {
        return moment(this.selectedDate).format("YYYY-MM-DD");
      }
    },
  },
  data() {
    return {
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD", // Uses 'iso' if missing
      },
     selectedDate: this.mode === 'range' ? {
       start: '',
       end: ''
     } : '',
      masks: {
        input: [ "YYYY-MM-DD"],
        data: ["YYYY-MM-DD"],
      },
      image_src: "../../../assets/images/icons/solid/calendar.svg"
    };
  },  
  watch: {
    // whenever generic_date changes, this function will run
    generic_date(date) {
      console.log("date Changed");
      if(date && date[0] == ''){
        // they reset the date  -  clear the already selected date values
        this.selectedDate = this.mode === 'range' ? {
          start: '',
          end: ''
        } : '';
      } else if (date && date.length == 0) {
        this.selectedDate = this.mode === 'range' ? {
          start: '',
          end: ''
        } : '';
      } else if (date && date.length >0) {
        //check if it is a valid date
        let result = date.every(( elem ) => {
          return elem && this.isValidDate(elem)
        })
        if(result){
          if(this.mode == 'range'){
            this.selectedDate = {
              start: new Date(date[0]),
              end: new Date(date[1])
            }
          }else{
          	this.selectedDate = new Date(date)
          }
        }
      }
    }
  },
  created() {
	if(this.mode == 'range'){
		this.selectedDate = {
			start:'',
			end:''
		}
		if (this.generic_date && this.generic_date != null) {
			if(Array.isArray(this.generic_date)){
				this.selectedDate.start = new Date(this.generic_date[0])
				this.selectedDate.end = new Date(this.generic_date[1])
			}else{
				this.selectedDate.start = new Date(this.generic_date.start)
				this.selectedDate.end = new Date(this.generic_date.end)
			}
		}
	}else{
		if (this.generic_date && this.generic_date != null) {
			this.selectedDate = new Date(this.generic_date.start)
		}else{
			this.selectedDate = ''
		}
	}
  },
  methods: {
    isValidDate(dateString) {
      var regEx = /^\d{2}-\d{2}-\d{4}$/;
      return dateString.match(regEx) != null;
    },
    onDateRangeChange(event) {
      this.$emit("emitUpdatedDate", this.mode, this.filter_object, this.field_to_update, { date: this.formattedDate });
      this.$emit("input", this.selectedDate);
    },
    emitUpdatedDate() {
      this.$emit("emitUpdatedDate", this.field_to_update,{ date: this.formattedDate });
    },
    cleanDate(){
      this.selectedDate = ''
      this.$emit("emitUpdatedDate", this.mode, this.filter_object, this.field_to_update, { date: {start_date: '', end_date: ''} });
      this.datePickerImageSource()
    },
    datePickerImageSource(){
      if(this.selectedDate == null || this.selectedDate == ''){
        return require( "../../../assets/images/icons/solid/calendar.svg")
      }else{
        return require( "../../../assets/images/delete-cancel-icon.svg")
      }
    },
    datePickerImageWidth(){
      if(this.selectedDate == null || this.selectedDate == ''){
        return '16'
      }else{
        return '18'
      }
    }
  },
};
</script>
<style>
.vc-w-full {
  /* height: 30px; */
  border: none !important;
  border-radius: 0px !important;
  width: 100%;
}
.width-100-percent {
  width: 100%;
  position: relative;
}
.width-100-percent a{
  cursor: pointer;
}
.vc-text-base {
  color: var(--provider-table-font-color) !important;
  font-size: 14px !important;
  font-family: sans-serif !important;
  height: 30px !important;
  /* background-image: url("../../../assets/images/icons/solid/calendar.svg"); */
    /* background-image: url("../../../assets/images/delete-cancel-icon.svg"); */
  background-repeat: no-repeat;
  background-position: 94% 4px;
  background-size: 18px;
  min-width: 200px;
}
.calendar_clean{
    position: absolute;
    top: 3px;
    right: 4%;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/DatePickerView.vue